import { Tile, tileSVGLookup } from './types';

import jsx from '../jsx';

export const renderTiles = (tiles: Tile[], target: HTMLElement): void => {
  target.innerHTML = '';

  for (let i = 0; i < tiles.length; i++) {
    const tile = tiles[i];

    const elements: HTMLElement[] = [];
    switch (tile.value) {
      case '-':
        elements.push(
          <img
            src="/tiles/Haku.svg" // Haku by itself is a blank tile
            className="blank"
          />,
        );
        break;
      case 'X':
        elements.push(<img src="/tiles/Back.svg" alt={tile.value} />);
        break;
      case '?':
        elements.push(
          <img src="/tiles/Front.svg" alt={tile.value} />,
          <img src="/tiles/Blank.svg" alt={tile.value} />,
        );
        break;
      default:
        if (!tile.suit) {
          console.warn('No suit for tile!', tile);
          break;
        }

        elements.push(
          <img src="/tiles/Front.svg" alt={tile.value} />,
          <img
            src={tileSVGLookup[tile.suit][tile.aka ? '0' : tile.value]}
            alt={tile.value}
          />,
        );
        break;
    }

    const tileWrapper = (<div className="tileWrapper"></div>) as HTMLDivElement;
    const tileElement = (<div className="tile"></div>) as HTMLDivElement;
    elements.forEach((el) => tileElement.append(el));

    if (tile.modifier === 'rotated') {
      tileWrapper.classList.add('rotated');
    }

    if (tile.modifier === 'stacked') {
      tileWrapper.classList.add('stacked');
      tileWrapper.append(tileElement.cloneNode(true));
    }

    tileWrapper.append(tileElement);
    target.append(tileWrapper);
  }
};
